import React, { useState } from 'react'
import Navbar from '../Navbar'
import Sidebar from '../Sidebar'

function Header() {
  const [isHamburguer, setIsHamburguer] = useState(false)
  const toggleSideBar = () =>{
    setIsHamburguer(!isHamburguer)
    console.log(isHamburguer)
  }
  return (
    <>
    <Navbar toggleHamburger={toggleSideBar}></Navbar>
    {isHamburguer && 
    <Sidebar
      isOpen={isHamburguer}
      OnClose={toggleSideBar}
    />}
    </>
  )
  
}

export default Header 